module.exports = __webpack_public_path__ + "img/vertical_7_6_8003.ee4e5936.png";